import SplitIOHandler from 'chameleon/ui-stack/utilities/split-io-handler';

// Handle the opening of auto-assign PCs info modal and feature flag checking
export class AutoAssignInfoModal {
  static eventName = 'AutoAssignInfoModalEvent';
  static _cachedFlags = {};

  static trigger() {
    window.dispatchEvent(new Event(AutoAssignInfoModal.eventName));
  }

  static listen(callback) {
    window.addEventListener(AutoAssignInfoModal.eventName, callback);
  }

  static checkFlag(pair) {
    return new Promise((resolve, reject) => {
      if (AutoAssignInfoModal._cachedFlags[pair]) {
        resolve(AutoAssignInfoModal._cachedFlags[pair]);
        return;
      }
      const flagHandler = new SplitIOHandler({
        key: pair,
        splitName: 'auto_assigned_pcs',
        attributes: {},
        callback: (treatment) => {
          if (treatment === 'on') {
            AutoAssignInfoModal._cachedFlags[pair] = true;
            resolve(true);
          } else if (treatment === 'off') {
            AutoAssignInfoModal._cachedFlags[pair] = false;
            resolve(false);
          } else {
            reject(new Error('P2 Flag error'));
          }
        },
      });
      flagHandler.invoke();
    });
  }
}
